import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toaster } from '@servicetitan/anvil2';
import { Provider, useDependencies } from '@servicetitan/react-ioc';
import { useCallback, useEffect, useRef, useState, useSyncExternalStore, } from 'react';
import { NotificationsApi } from '../api/notifications.api';
import { NotificationsStore } from '../stores/notifications.store';
import { useCompatibleNavigate } from '../utils/use-compatible-navigate';
import { NotificationsService } from '../notifications-service';
export const Notifications = ({ apiService, children }) => (_jsxs(Provider, { singletons: [
        ...(apiService ? [{ provide: NotificationsApi, useClass: apiService }] : []),
        NotificationsStore,
        NotificationsService,
    ], children: [_jsx(NotificationsUnwrapped, {}), children] }));
const NotificationsUnwrapped = () => {
    // Configure and clean up store
    const [store] = useDependencies(NotificationsStore);
    const navigate = useCompatibleNavigate();
    useEffect(() => {
        store.navigate = navigate;
        return () => {
            store.dispose();
        };
    }, [store, navigate]);
    // Use useSyncExternalStore to ensure we re-render when the active id changes
    const [thisId] = useState(() => makeId());
    const syncExternalStoreCallback = useRef();
    const subscribe = useCallback((callback) => {
        syncExternalStoreCallback.current = callback;
        return () => (syncExternalStoreCallback.current = undefined);
    }, []);
    const activeId = useSyncExternalStore(subscribe, () => globalThis.STNotificationsActiveId);
    // Set and clean up active id
    useEffect(() => {
        var _a;
        if (globalThis.STNotificationsActiveId === undefined) {
            globalThis.STNotificationsActiveId = thisId;
            (_a = syncExternalStoreCallback.current) === null || _a === void 0 ? void 0 : _a.call(syncExternalStoreCallback);
        }
        return () => {
            var _a;
            if (globalThis.STNotificationsActiveId === thisId) {
                globalThis.STNotificationsActiveId = undefined;
                (_a = syncExternalStoreCallback.current) === null || _a === void 0 ? void 0 : _a.call(syncExternalStoreCallback);
            }
        };
    }, [syncExternalStoreCallback, thisId]);
    return activeId === thisId ? _jsx(Toaster, { id: 'st-notifications-' + thisId }) : null;
};
function makeId() {
    return Math.round(1e8 * Math.random()).toString(36);
}
//# sourceMappingURL=notifications.js.map